define.alias("shared/utils/number-helpers/compute-sign", "preview-grid/utils/number-helpers/compute-sign");